"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _emptyFunction = _interopRequireDefault(require("react-utils/emptyFunction"));

var _components = require("I18n/components");

var _UIOptConstants = require("ui-addon-opt/constants/UIOptConstants");

var _Feedback = require("ui-addon-opt/lib/Feedback");

var _Tracking = require("ui-addon-opt/lib/Tracking");

var _OptStateReducer = require("ui-addon-opt/state/OptStateReducer");

var _OptState = require("ui-addon-opt/state/OptState");

var _RejectConfirmationModal = _interopRequireDefault(require("ui-addon-opt/components/RejectConfirmationModal"));

var _OptEffects = require("ui-addon-opt/effects/OptEffects");

var _Optin = _interopRequireDefault(require("./Optin"));

var _Optout = _interopRequireDefault(require("./Optout"));

var _OptLoading = _interopRequireDefault(require("./OptLoading"));

var initialOptSettings = {
  availability: {}
};

var UIOpt = function UIOpt(_ref) {
  var learnMoreText = _ref.learnMoreText,
      notifyOnUserViewChangesOnly = _ref.notifyOnUserViewChangesOnly,
      onFetchOptError = _ref.onFetchOptError,
      onInitialOptStateFetched = _ref.onInitialOptStateFetched,
      onLearnMoreClick = _ref.onLearnMoreClick,
      onOptStateChangeCancelled = _ref.onOptStateChangeCancelled,
      onOptStateChanged = _ref.onOptStateChanged,
      onTargetOptinViewChanged = _ref.onTargetOptinViewChanged,
      onUpdateOptError = _ref.onUpdateOptError,
      optInButtonText = _ref.optInButtonText,
      OptInConfirmationModal = _ref.OptInConfirmationModal,
      optinName = _ref.optinName,
      optinView = _ref.optinView,
      optOutButtonText = _ref.optOutButtonText,
      showIcon = _ref.showIcon,
      tracker = _ref.tracker;

  var _useState = (0, _react.useState)(initialOptSettings),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      optSettings = _useState2[0],
      setOptSettings = _useState2[1];

  var _useReducer = (0, _react.useReducer)(_OptStateReducer.optStateReducer, (0, _OptStateReducer.createInitialOptState)()),
      _useReducer2 = (0, _slicedToArray2.default)(_useReducer, 2),
      opt = _useReducer2[0],
      dispatch = _useReducer2[1];

  var ConfirmationModal = (0, _OptState.getConfirmationOptions)({
    opt: opt,
    OptInConfirmationModal: OptInConfirmationModal,
    RejectConfirmationModal: _RejectConfirmationModal.default
  });
  var usageTracker = (0, _OptEffects.useUsageTracker)(tracker);
  var learnMore = (0, _OptState.getLearnMoreConfig)(optSettings, learnMoreText);
  (0, _OptEffects.useFetchUserOptSettingsEffect)({
    dispatch: dispatch,
    optinName: optinName,
    optinView: optinView,
    onFetchOptError: onFetchOptError,
    opt: opt,
    setOptSettings: setOptSettings
  });
  (0, _OptEffects.useUpdateUserOptSettingsEffect)({
    ConfirmationModal: ConfirmationModal,
    dispatch: dispatch,
    optinName: optinName,
    onOptStateChangeCancelled: onOptStateChangeCancelled,
    onUpdateOptError: onUpdateOptError,
    opt: opt,
    optSettings: optSettings
  });
  (0, _OptEffects.useTargetOptinViewChangedEffect)({
    notifyOnUserViewChangesOnly: notifyOnUserViewChangesOnly,
    onTargetOptinViewChanged: onTargetOptinViewChanged,
    opt: opt,
    optSettings: optSettings,
    optinView: optinView
  });
  (0, _OptEffects.useInitialOptStateFetchedEffect)({
    onInitialOptStateFetched: onInitialOptStateFetched,
    optSettings: optSettings
  });
  (0, _OptEffects.useOptStateChangedEffect)({
    opt: opt,
    onOptStateChanged: onOptStateChanged,
    optinName: optinName,
    usageTracker: usageTracker
  });
  var onLearnMoreClickCb = (0, _react.useCallback)(function () {
    onLearnMoreClick(optSettings.availability.state);
    (0, _Tracking.trackLearnMoreClick)(usageTracker, optinName);
  }, [onLearnMoreClick, optSettings.availability.state, optinName, usageTracker]);
  var onFeedbackSurveyClickCb = (0, _react.useCallback)(function () {
    (0, _Feedback.showFeedbackSurvey)(optSettings.availability.feedbackSurveyId);
    (0, _Tracking.trackFeedbackSurveyClick)(usageTracker, optinName);
  }, [optSettings.availability.feedbackSurveyId, optinName, usageTracker]);
  var onViewCb = (0, _react.useCallback)(function () {
    (0, _Tracking.trackOptView)(usageTracker, optinName);
  }, [optinName, usageTracker]);

  if (!optSettings.user || !(0, _OptState.show)(optSettings)) {
    return null;
  }

  if (optinView !== opt.optinView) {
    return _react.default.createElement(_OptLoading.default, null);
  }

  if ((0, _OptState.showOptin)(optSettings)) {
    return _react.default.createElement(_Optin.default, {
      dispatch: dispatch,
      learnMore: learnMore,
      onLearnMoreClick: onLearnMoreClickCb,
      onView: onViewCb,
      optInButtonText: optInButtonText,
      showHubOptin: (0, _OptState.canHubOptin)(optSettings),
      showUserOptin: (0, _OptState.canUserOptin)(optSettings),
      showIcon: showIcon
    });
  }

  if ((0, _OptState.showOptout)(optSettings, {
    feedbackSurveyId: optSettings.availability.feedbackSurveyId,
    learnMore: learnMore
  })) {
    return _react.default.createElement(_Optout.default, {
      dispatch: dispatch,
      feedbackSurveyId: optSettings.availability.feedbackSurveyId,
      learnMore: learnMore,
      onFeedbackSurveyClick: onFeedbackSurveyClickCb,
      onLearnMoreClick: onLearnMoreClickCb,
      onView: onViewCb,
      optOutButtonText: optOutButtonText,
      showHubOptin: (0, _OptState.canHubOptinFromOptout)(optSettings),
      showHubOptout: (0, _OptState.canHubOptout)(optSettings),
      showIcon: showIcon,
      showUserOptout: (0, _OptState.canUserOptout)(optSettings)
    });
  }

  return null;
};

UIOpt.propTypes = {
  learnMoreText: _propTypes.default.node,
  notifyOnUserViewChangesOnly: _propTypes.default.bool.isRequired,
  onFetchOptError: _propTypes.default.func.isRequired,
  onInitialOptStateFetched: _propTypes.default.func.isRequired,
  onLearnMoreClick: _propTypes.default.func.isRequired,
  onOptStateChangeCancelled: _propTypes.default.func.isRequired,
  onOptStateChanged: _propTypes.default.func.isRequired,
  onTargetOptinViewChanged: _propTypes.default.func.isRequired,
  onUpdateOptError: _propTypes.default.func.isRequired,
  optInButtonText: _propTypes.default.node,
  OptInConfirmationModal: _propTypes.default.func,
  optinName: _propTypes.default.string.isRequired,
  optinView: _propTypes.default.oneOf([_UIOptConstants.OPTIN_VIEW_NEW, _UIOptConstants.OPTIN_VIEW_CURRENT]).isRequired,
  optOutButtonText: _propTypes.default.node,
  showIcon: _propTypes.default.bool.isRequired,
  tracker: _propTypes.default.shape({
    clone: _propTypes.default.func.isRequired,
    track: _propTypes.default.func.isRequired
  })
};
UIOpt.defaultProps = {
  learnMoreText: _react.default.createElement(_components.FormattedMessage, {
    message: "ui-addon-opt.learnMoreLabel"
  }),
  notifyOnUserViewChangesOnly: false,
  onFetchOptError: _emptyFunction.default,
  onInitialOptStateFetched: _emptyFunction.default,
  onLearnMoreClick: _emptyFunction.default,
  onOptStateChangeCancelled: _emptyFunction.default,
  onOptStateChanged: _emptyFunction.default,
  onTargetOptinViewChanged: _emptyFunction.default,
  onUpdateOptError: _emptyFunction.default,
  optinView: _UIOptConstants.OPTIN_VIEW_CURRENT,
  showIcon: true
};
var _default = UIOpt;
exports.default = _default;
module.exports = exports.default;